module.exports = __webpack_public_path__ + "img/Business Plan-amico.692e6023.svg";